export default __webpack_public_path__ + "static/media/HibaResume.9f3c9d19.pdf";